import {
  BrowserRouter as Router,
  Routes,
  Route
} from "react-router-dom";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Home from "./components/Home";
import OCR from "./components/OCR";
import Edit from "./components/Edit";
import AdminPage from "./components/AdminPage";
import CardSelector from "./components/CardSelector";


function App() {
  return (
    <>
      <Router>
        <Routes>
        <Route exact path="/" element={<Home />} />
        <Route exact path="/adminPage" element={<AdminPage />} />
        <Route exact path="/ocr" element={<OCR />} />
        <Route exact path="/select-card" element={<CardSelector />} />
        <Route exact path="/display" element={<Edit />} />
        </Routes>
        <ToastContainer position="top-center" autoClose={1000} />
      </Router>
    </>
  );
}

export default App;